export function getTopTenDataForLead(data, lead) {
  const suffixedData =
    data?.[`topTenData_${lead}`] ?? data?.[`topTenData${lead}`];

  if (suffixedData?.top_ten) return suffixedData;

  if (Array.isArray(data?.topTenData)) {
    return data.topTenData[lead - 1] || null;
  }

  const groupedData = data?.topTenData;
  const groupedRecord = groupedData?.[lead] ?? groupedData?.[String(lead)];
  if (groupedRecord?.top_ten) return groupedRecord;

  const groupedValue = groupedData?.[`top_ten_${lead}`];
  if (groupedValue) {
    return { ...groupedData, top_ten: groupedValue };
  }

  // Unsuffixed legacy MEF records belong to Lead 1.
  if (lead === 1 && groupedData?.top_ten) return groupedData;

  return null;
}
